import constants from 'constants';

const {
  ADD_DISCIPLINES,
  ADD_NEW_DISCIPLINES,
  ADD_ADMIN_DISCIPLINES,
  CLEAN_DISCIPLINES,
  SET_TEMP_DISCIPLINE,
  SET_DISCIPLINES,
  ADD_SEARCH_DISCIPLINES
} = constants;

const disciplines = (disciplines = {
  list: {
    values: [],
    isLoaded: false
  },
  search: {
    values: [],
    isLoaded: false
  },
  newDisciplines: {
    values: [],
    isLoaded: false
  },
  admin: {
    list: {
      values: [],
      page: 0,
      pages: 0,
      total_pages: 0,
      query: {
        title: '',
        order: {
          created_at: 'desc'
        }
      }
    },
    tmp: {}
  }
}, {
                       type,
                       payload
                     }) => {
  switch (type) {
    case ADD_DISCIPLINES:
      return {
        ...disciplines,
        ...{
          list: {
            values: payload.values,
            page: payload.page,
            total_pages: payload.total_pages,
            count: payload.count
          }
        }
      }
    case ADD_SEARCH_DISCIPLINES:
      return {
        ...disciplines,
        ...{
          search: {
            values: payload.values,
            page: payload.page,
            total_pages: payload.total_pages,
            count: payload.count
          }
        }
      }
    case ADD_NEW_DISCIPLINES:
      return {
        ...disciplines,
        ...{
          newDisciplines: {
            values: payload.values,
            page: payload.page,
            total_pages: payload.total_pages,
            count: payload.count
          }
        }
      }
    case ADD_ADMIN_DISCIPLINES:
      return {
        ...disciplines,
        ...{
          admin: {
            ...disciplines.admin,
            list: {
              values: payload.values,
              page: payload.page,
              total_pages: payload.total_pages,
              count: payload.count
            }
          }
        }
      }
    case SET_DISCIPLINES:
      return {
        ...disciplines,
        ...{
          list: {
            ...disciplines.list,
            values: payload
          }
        }
      }
    case CLEAN_DISCIPLINES:
      return {
        ...disciplines,
        admin: {
          ...disciplines.admin,
          list: {
            values: [],
            page: 0,
            pages: 0,
            total_pages: 0,
            query: {
              title: '',
              order: {
                created_at: 'desc'
              }
            }
          },
          tmp: {}
        }
      }
    case SET_TEMP_DISCIPLINE:
      return {
        ...disciplines,
        admin: {
          ...disciplines.admin,
          tmp: payload.discipline
        }
      }
    default:
      return disciplines
  }
}

export { disciplines };



// WEBPACK FOOTER //
// ./src/reducers/disciplines.js